import React from "react";
import types from "./types";

const ArtBoard = ({ size, color, ...props }) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill={color} />
  </svg>
);

ArtBoard.propTypes = types.propTypes;
ArtBoard.defaultProps = types.defaultProps;

export default ArtBoard;
